import React from "react";
import {message, Modal} from "antd";
import TooltipIcon from "../Boilerplate/TooltipIcon";
import PropTypes from "prop-types";

export class UnfollowButton extends React.Component {
  state = { disabled: false };

  handleClick = project => {
    if (!this.state.disabled) {
      this.setState({ disabled: true });
      message.info('Unfollowing project ' + project.resource.name);
      this.props.onLeave && this.props.onLeave(project.resource.id);
    }
  };

  confirmLeave = project => {
    let leave = Modal.confirm({
      title: 'Are you sure you want to unfollow this project?',
      content: <span>If you unfollow this project, it will be removed from your list immediately. To regain access to this project, you will need to be re-invited.</span>,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => this.handleClick(project),
    })
  };

  render() {
    return <a key={this.props.fauxKey} onClick={() => this.confirmLeave(this.props.project)}>
      <TooltipIcon title={this.props.title} type={!this.state.disabled ? this.props.type : 'loading'}
                   theme={!this.state.disabled ? 'filled' : ''} iconStyle={{ fontSize: 22 }}/>
    </a>;
  }
}

UnfollowButton.propTypes = {
  onLeave: PropTypes.func,
  fauxKey: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/Projects/UnfollowButton.js